import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import cx from 'classnames';
import css from './FootnoteNodeView.module.scss';

export const FootnoteNodeView = ({ selected }: NodeViewProps) => {
  return (
    <NodeViewWrapper as="span">
      <sup
        className={cx(css.reference, {
          [css.selected]: selected,
        })}
        contentEditable={false}
      />
    </NodeViewWrapper>
  );
};
